import { Grid } from "@generalapplications/ui";

import { RevealGroup } from "@/app/common/components/composite/motion/RevealGroup";
import { deliveryProcess } from "@/content/delivery";
import type { ServiceRecord } from "@/content/services";
import { PhaseCard, type AccordionItemType } from "./PhaseCard";

export type { AccordionItemType };

export type DeliveryPhasesProps = {
  phases?: ServiceRecord["phases"];
  defaultOpenPhaseId?: string;
  defaultOpenItem?: AccordionItemType;
};

/** The four delivery phases every service runs through, with this one's detail. */
export function DeliveryPhases({
  phases,
  defaultOpenPhaseId,
  defaultOpenItem,
}: DeliveryPhasesProps) {
  return (
    <RevealGroup>
      <Grid
        as="ol"
        aria-label="Delivery phases"
        columns={{ base: 1, sm: 2, lg: 4 }}
        gap="lg"
      >
        {deliveryProcess.phases.map((phase) => (
          <PhaseCard
            key={phase.id}
            phase={phase}
            detail={phases?.[phase.id]}
            defaultOpenItem={
              phase.id === defaultOpenPhaseId ? defaultOpenItem : null
            }
          />
        ))}
      </Grid>
    </RevealGroup>
  );
}
